import React, { Component } from 'react';

class Clock extends Component {
  constructor(props) {
    super(props)

    this.getTime = this.getTime.bind(this)
    this.getNextTime = this.getNextTime.bind(this)
  }

  state = {
    time: this.getTime(),
  }

  getTime() {
    const today = new Date();
    let h = today.getHours();
    let m = today.getMinutes();
    m = this.zeroPad(m);

    return h + ":" + m
  }

  zeroPad(i) {
    if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
    return i;
  }

  getNextTime() {
    this.setState({ time: this.getTime() })

    const timeout_id = setTimeout(this.getNextTime.bind(this), 1000)
    this.setState(prevState => {
      clearTimeout(prevState.timeout_id)

      return { timeout_id: timeout_id }
    })
  }

  render() {
    return <div className={"clock"}>{this.state.time}</div>
  }

  componentDidMount() {
    this.getNextTime()
  }

  componentWillUnmount() {
    clearTimeout(this.state.timeout_id)
  }
}

export default Clock;
